/**
 * Vínculo de tablet a posto (ADR 0010).
 *
 * A gestão gera um código curto de uso único para um posto; quem digita o
 * código no tablet recebe um token opaco, guardado no dispositivo, que passa
 * a identificar "este tablet é o do posto X". Aqui fica só a regra pura:
 * formato e normalização do código, validade e situação (válido, expirado,
 * usado). Sorteio, hash e persistência ficam na API.
 */
/** Header HTTP em que o tablet manda o token opaco do dispositivo. */
export const HEADER_DISPOSITIVO = 'x-dispositivo';
/**
 * Código tRPC devolvido quando a chamada não vem de um tablet vinculado ao
 * posto. Distinto de FORBIDDEN de propósito: o web o usa para mostrar a tela
 * de vínculo em vez de "sem permissão".
 */
export const CODIGO_SEM_DISPOSITIVO = 'PRECONDITION_FAILED';
/** Sem 0/O e 1/I: o código é ditado por telefone e digitado em tela de toque. */
export const ALFABETO_CODIGO_VINCULO = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const TAMANHO_CODIGO_VINCULO = 6;
/** Janela para digitar o código no tablet depois de gerado na gestão. */
export const VALIDADE_CODIGO_VINCULO_MIN = 10;
const REGEX_CODIGO_VINCULO = new RegExp(`^[${ALFABETO_CODIGO_VINCULO}]{${TAMANHO_CODIGO_VINCULO}}$`);
/**
 * Sorteia um código. `sortear(max)` devolve um inteiro em [0, max): a API
 * passa `crypto.randomInt`; o padrão serve para testes e protótipos.
 */
export function gerarCodigoVinculo(sortear = (max) => Math.floor(Math.random() * max)) {
    let codigo = '';
    for (let i = 0; i < TAMANHO_CODIGO_VINCULO; i++) {
        codigo += ALFABETO_CODIGO_VINCULO[sortear(ALFABETO_CODIGO_VINCULO.length)];
    }
    return codigo;
}
/** "abc-234", " ABC 234 " → "ABC234". Não valida: use `codigoVinculoValido`. */
export function normalizarCodigoVinculo(entrada) {
    return entrada.toUpperCase().replace(/[^A-Z0-9]/g, '');
}
export const codigoVinculoValido = (codigo) => REGEX_CODIGO_VINCULO.test(codigo);
/** "ABC234" → "ABC-234", para ler em voz alta e conferir na tela. */
export function formatarCodigoVinculo(codigo) {
    const metade = Math.ceil(codigo.length / 2);
    return `${codigo.slice(0, metade)}-${codigo.slice(metade)}`;
}
export function expiracaoDoCodigoVinculo(geradoEm) {
    return new Date(geradoEm.getTime() + VALIDADE_CODIGO_VINCULO_MIN * 60_000);
}
/** Usado vence expirado: um código já trocado nunca vale de novo, mesmo dentro do prazo. */
export function situacaoDoCodigoVinculo(codigo, agora) {
    if (codigo.usadoEm)
        return 'usado';
    if (codigo.expiraEm.getTime() <= agora.getTime())
        return 'expirado';
    return 'valido';
}
export const MENSAGEM_CODIGO_VINCULO = {
    usado: 'Este código já foi usado. Peça um novo à gestão.',
    expirado: 'Este código venceu. Peça um novo à gestão.',
};
//# sourceMappingURL=vinculo.js.map